<div class="cs-tab-container cs-tab-container--panel"
	 [class.cs-tab-container--left]="align === 'left'"
	 [class.cs-tab-container--center]="align === 'center'"
	 [class.cs-tab-container--right]="align === 'right'">
	<ng-container *ngFor="let tab of tabs">
		<div class="cs-tab-item"
			 [class.active]="tab.key === activeTab"
			 (click)="switchTab(tab)">
			<i *ngIf="tab.icon" class="mdi {{tab.icon}}"></i>
			<label>{{ tab.label }}</label>
		</div>
	</ng-container>
</div>
